import Inventario from './Inventario';
export default Inventario;